/**
     * @desc //15查询已开盲盒对应的NFT列表
开盲盒之后，getOrderStatus返回1时调用
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/box/getOpenedNftList', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/box/getOpenedNftList', params);
}
